module.exports = __webpack_public_path__ + "media/images/TestsInc. Logo 1-6d269e346e991d29f89790e5bf446459.svg";